(() => {
  if (window.__bbCartDiscountBound) return;
  window.__bbCartDiscountBound = true;
  const storageKey = 'bb-discount-attempt';

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[data-bb-discount-form]');
    if (!form) return;
    event.preventDefault();
    const input = form.querySelector('input[name="bb_discount_code"]');
    const code = input ? input.value.trim() : '';
    if (!code) {
      if (input) input.focus();
      return;
    }
    try {
      sessionStorage.setItem(storageKey, JSON.stringify({ code, at: Date.now() }));
    } catch (_) { /* Storage may be unavailable; discount redirect still works. */ }
    const root = form.dataset.root || '/';
    const prefix = root.endsWith('/') ? root : root + '/';
    const target = new URL(prefix + 'discount/' + encodeURIComponent(code), window.location.origin);
    target.searchParams.set('redirect', prefix + 'cart');
    window.location.assign(target.toString());
  });

  function showDiscountFeedback() {
    const form = document.querySelector('form[data-bb-discount-form][data-bb-source="cart-page"]');
    const panel = form && form.closest('.bb-cart-discount');
    if (!panel || !window.location.pathname.replace(/\/$/, '').endsWith('/cart')) return;
    const status = panel.querySelector('.bb-cart-discount__status');
    if (!status) return;
    let saved;
    try {
      saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      if (saved) sessionStorage.removeItem(storageKey);
    } catch (_) { return; }
    if (!saved || typeof saved.code !== 'string' || Date.now() - Number(saved.at) > 300000) return;
    const code = saved.code;
    const appliedTitles = (panel.dataset.bbAppliedTitles || '').split('|').map((s) => s.trim().toLowerCase());
    const applied = appliedTitles.includes(code.toLowerCase());
    const german = document.documentElement.lang.toLowerCase().startsWith('de');
    status.textContent = applied
      ? (german ? 'Rabattcode „' + code + '“ wird im Warenkorb berücksichtigt.' : 'Discount code “' + code + '” is applied in the cart.')
      : (german ? 'Code „' + code + '“ eingegeben. Falls noch kein Rabatt erscheint, wird er im Checkout geprüft.' : 'Code “' + code + '” entered. If no discount is shown yet, it will be checked at checkout.');
    status.dataset.state = applied ? 'applied' : 'pending';
    status.hidden = false;
    const input = form.querySelector('input[name="bb_discount_code"]');
    if (input && !input.value) input.value = code;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showDiscountFeedback, { once: true });
  } else {
    showDiscountFeedback();
  }
})();
